import styled from "styled-components";
import {Tooltip} from "ui/base/tooltip/Tooltip";
import {USDollar} from "utils";

export const TotalCostTooltip = ({
                                     costData: {classCost, discount, tax, totalCost},
                                 }) => (
    <Tooltip
        id="TotalCost"
        text={
            <TooltipWrapper>
                <StyledListOfCosts>
                    <CostListItem>
                        <span>Class cost</span>
                        <span>{USDollar.format(classCost)}</span>
                    </CostListItem>
                    {!!discount ? (
                        <CostListItem>
                            <span>Discount</span>
                            <span>-{USDollar.format(discount)}</span>
                        </CostListItem>
                    ) : null}
                    <CostListItem>
                        <span>Tax</span>
                        <span>{USDollar.format(tax)}</span>
                    </CostListItem>
                    <CostListItem>
                        <TotalCostItem>Total cost</TotalCostItem>
                        <span>{USDollar.format(totalCost)}</span>
                    </CostListItem>
                </StyledListOfCosts>
            </TooltipWrapper>
        }
    />
);

const TooltipWrapper = styled.div`
    padding: 4px;
`;

const StyledListOfCosts = styled.ul`
    display: grid;
    gap: 4px;
    font-size: 14px;
    color: #191d3a60;
`;

const CostListItem = styled.li`
    display: flex;
    justify-content: space-between;
    gap: 20px;
`;

const TotalCostItem = styled.span`
    color: #191d3a;
`;
